// Shared with App.tsx (learning/XP/completion tracking) and CategorySelection.tsx
// (progress bars, chunk labels like "Lire les hiéroglyphes · 1", "X franchies").
// Both must agree on which cards in Kama data are real vocabulary vs. pure
// narrative/methodology, or a category/chunk can end up with a "learned" count
// that can never reach its own displayed total (e.g. stuck at "15/20").
export const KAMA_NON_VOCAB_CATEGORIES = new Set([
  'Lecture analytique',
  'Lecture analytique — déterminatifs',
  'Lecture analytique — Kemet',
  'Lecture analytique — histoire',
  'Phrase',
  'Phrase — le nom',
  'Phrase — pronoms',
  'Sur les murs des temples',
]);

export const KAMA_NON_VOCAB_KEYS_IN_LECTURE = new Set([
  'Translittération',
  'Qu\'est-ce qu\'un signe directeur ?',
  'Signe directeur',
  'km (exercice)',
  'Msḫnt (exercice)',
  'Ỉmn (exercice)',
  'Nwt (exercice)',
  'Diodore de Sicile',
  'Pierre de Rosette',
  'Cartouche',
  'Ptwlmys',
  'l / m',
  'Champollion',
  // End-of-chapter reviews (isChapterReview): a sound → sign check, not a word.
  'Révision : voyelles conventionnelles',
  'Révision : sons des lèvres',
  'Révision : la langue contre le palais',
  'Révision : les quatre h',
  'Révision : les sifflantes',
  'Révision : le fond de la gorge',
  'Révision : les dentales',
]);
